function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L20 0L20 20L0 20L0 0Z",
  id: "joystick_path_1"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "joystick_mask_1"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#joystick_path_1"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "joystick-(2)-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L20 0L20 20L0 20L0 0Z",
  id: "joystick-(2)-1-(Background/Mask)",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#joystick_mask_1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(2.6679688 11.999512)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.66613 1.66642L3.66613 0.333285C3.66613 0.149228 3.5169 0 3.33285 0L1.99971 0C1.81565 0 1.66642 0.149228 1.66642 0.333285L1.66642 1.66642L0.333285 1.66642C0.149228 1.66642 0 1.81565 0 1.99971L0 3.33285C0 3.5169 0.149228 3.66613 0.333285 3.66613L1.66642 3.66613L1.66642 4.99927C1.66642 5.18333 1.81565 5.33256 1.99971 5.33256L3.33285 5.33256C3.5169 5.33256 3.66613 5.18333 3.66613 4.99927L3.66613 3.66613L4.99927 3.66613C5.18333 3.66613 5.33256 3.5169 5.33256 3.33285L5.33256 1.99971C5.33256 1.81565 5.18333 1.66642 4.99927 1.66642L3.66613 1.66642ZM3.33285 2.99956C3.14879 2.99956 2.99956 3.14879 2.99956 3.33285L2.99956 4.66599L2.33299 4.66599L2.33299 3.33285C2.33299 3.14879 2.18376 2.99956 1.99971 2.99956L0.666569 2.99956L0.666569 2.33299L1.99971 2.33299C2.18376 2.33299 2.33299 2.18377 2.33299 1.99971L2.33299 0.66657L2.99956 0.66657L2.99956 1.99971C2.99956 2.18377 3.14879 2.33299 3.33285 2.33299L4.66599 2.33299L4.66599 2.99956L3.33285 2.99956Z",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(0 0.0009765625)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.2538 9.3653C15.0586 9.34376 14.8624 9.33264 14.6659 9.33197L10.9998 9.33197L10.9998 7.99883L10.3332 7.99883L10.3332 7.33226C10.3332 6.596 9.73636 5.99912 9.00009 5.99912L7.33367 5.99912C6.96551 5.99912 6.6671 5.70071 6.6671 5.33256C6.6671 4.9644 6.96551 4.66599 7.33367 4.66599L12.6662 4.66599C13.4025 4.66599 13.9994 4.06911 13.9994 3.33285C13.9994 2.59658 13.4025 1.99971 12.6662 1.99971L10.9998 1.99971C10.6316 1.99971 10.3332 1.70129 10.3332 1.33314L10.3332 0L9.66666 0L9.66666 1.33314C9.66666 2.06941 10.2635 2.66628 10.9998 2.66628L12.6662 2.66628C13.0344 2.66628 13.3328 2.96469 13.3328 3.33285C13.3328 3.701 13.0344 3.99942 12.6662 3.99942L7.33367 3.99942C6.5974 3.99942 6.00053 4.59629 6.00053 5.33256C6.00053 6.06882 6.5974 6.66569 7.33367 6.66569L9.00009 6.66569C9.36825 6.66569 9.66666 6.96411 9.66666 7.33226L9.66666 7.99883L9.00009 7.99883L9.00009 9.33197L5.33396 9.33197C5.13732 9.33243 4.94081 9.34355 4.74538 9.3653C2.44572 9.61193 0.29003 11.7606 0.035067 14.0573C-0.299759 16.9833 1.80077 19.6267 4.7268 19.9615C5.91829 20.0979 7.12095 19.8286 8.14055 19.1972C8.57953 18.9099 9.08129 18.7326 9.60334 18.6803C9.86122 18.6599 10.1202 18.659 10.3782 18.6776C10.9085 18.7289 11.4184 18.9083 11.864 19.2002C14.3693 20.7485 17.6553 19.9728 19.2036 17.4675C19.8336 16.4481 20.1019 15.2461 19.9652 14.0556C19.7095 11.7589 17.5525 9.61026 15.2538 9.3653ZM10.3332 8.6654L10.3332 9.33197L9.66666 9.33197L9.66666 8.6654L10.3332 8.6654ZM12.2153 18.6336C11.6783 18.284 11.064 18.0708 10.4259 18.0127C10.2852 18.0025 10.1433 17.9974 9.99995 17.9974C9.8483 17.9974 9.69999 18.0037 9.55068 18.0154C8.92223 18.0756 8.31765 18.2866 7.78827 18.6306C5.59684 19.9865 2.72122 19.3091 1.36533 17.1177C0.81337 16.2256 0.578154 15.1735 0.697637 14.1313C0.916938 12.1576 2.84132 10.2405 4.81704 10.0282C4.98868 10.009 5.16124 9.99912 5.33396 9.99854L14.6659 9.99854C14.8386 9.99867 15.0112 10.0079 15.1829 10.0262C17.1582 10.2385 19.0823 12.1556 19.3023 14.1293C19.4594 15.4548 19.0372 16.7837 18.1438 17.7754C16.6369 19.4608 14.1382 19.8225 12.2153 18.6336Z",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(13.333008 11.333008)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 1.33314C0 2.06941 0.596871 2.66628 1.33314 2.66628C2.06941 2.66628 2.66628 2.06941 2.66628 1.33314C2.66628 0.596871 2.06941 0 1.33314 0C0.596871 0 0 0.596871 0 1.33314ZM0.666569 1.33314C0.666569 0.964984 0.964984 0.666569 1.33314 0.666569C1.70129 0.666569 1.99971 0.964984 1.99971 1.33314C1.99971 1.70129 1.70125 1.99971 1.33314 1.99971C0.964984 1.99971 0.666569 1.70129 0.666569 1.33314Z",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(13.333008 15.332031)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 1.33314C0 2.06941 0.596871 2.66628 1.33314 2.66628C2.06941 2.66628 2.66628 2.06941 2.66628 1.33314C2.66628 0.596871 2.06941 0 1.33314 0C0.596871 0 0 0.596871 0 1.33314ZM0.666569 1.33314C0.666569 0.964984 0.964984 0.666569 1.33314 0.666569C1.70129 0.666569 1.99971 0.964984 1.99971 1.33314C1.99971 1.70129 1.70125 1.99971 1.33314 1.99971C0.964984 1.99971 0.666569 1.70129 0.666569 1.33314Z",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(11 13.33252)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 1.33314C0 2.06941 0.596871 2.66628 1.33314 2.66628C2.06941 2.66628 2.66628 2.06941 2.66628 1.33314C2.66628 0.596871 2.06941 0 1.33314 0C0.596871 0 0 0.596871 0 1.33314ZM0.666569 1.33314C0.666569 0.964985 0.964984 0.66657 1.33314 0.66657C1.70129 0.66657 1.99971 0.964985 1.99971 1.33314C1.99971 1.70129 1.70125 1.99971 1.33314 1.99971C0.964984 1.99971 0.666569 1.70129 0.666569 1.33314Z",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(15.666016 13.33252)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 1.33314C0 2.06941 0.596871 2.66628 1.33314 2.66628C2.06941 2.66628 2.66628 2.06941 2.66628 1.33314C2.66628 0.596871 2.06941 0 1.33314 0C0.596871 0 0 0.596871 0 1.33314ZM0.666569 1.33314C0.666569 0.964985 0.964984 0.66657 1.33314 0.66657C1.70129 0.66657 1.99971 0.964985 1.99971 1.33314C1.99971 1.70129 1.70125 1.99971 1.33314 1.99971C0.964984 1.99971 0.666569 1.70129 0.666569 1.33314Z",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
})))));

var SvgJoystick = function SvgJoystick(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJoystick, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/joystick.6c6af189.svg";
export { ForwardRef as ReactComponent };